function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "70",
  viewBox: "0 0 80 61",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1966_115412)"
}, /*#__PURE__*/React.createElement("rect", {
  x: ".361",
  y: "1.082",
  width: "37.277",
  height: "27.057",
  rx: ".361",
  fill: "#FAFAFA"
}), /*#__PURE__*/React.createElement("rect", {
  x: "2",
  y: "2.721",
  width: "6",
  height: "6",
  rx: "1",
  fill: "#59C3C3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.099 4.712a.196.196 0 01.32.225l-1.26 1.79a.196.196 0 01-.283.04l-.894-.721a.195.195 0 11.246-.304l.731.59 1.14-1.62z",
  fill: "#FAFAFA",
  stroke: "#FAFAFA",
  strokeWidth: ".455"
}), /*#__PURE__*/React.createElement("rect", {
  x: "15",
  y: "7.721",
  width: "8",
  height: "8",
  rx: "1",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "4",
  y: "18.721",
  width: "30",
  height: "2.89",
  rx: ".723",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: ".361",
  y: "1.082",
  width: "37.277",
  height: "27.057",
  rx: ".361",
  stroke: "#DDE0E4",
  strokeWidth: ".723"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_1966_115412)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  x: "42",
  y: ".721",
  width: "38",
  height: "27.78",
  rx: ".723"
})), /*#__PURE__*/React.createElement("rect", {
  x: "42",
  y: ".721",
  width: "38",
  height: "27.78",
  rx: ".723",
  fill: "#FAFAFA"
}), /*#__PURE__*/React.createElement("rect", {
  x: "44.5",
  y: "3.221",
  width: "5",
  height: "5",
  rx: ".5",
  stroke: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "57",
  y: "7.721",
  width: "8",
  height: "8",
  rx: "1",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "46",
  y: "18.721",
  width: "30",
  height: "2.89",
  rx: ".723",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "42",
  y: ".721",
  width: "38",
  height: "27.78",
  rx: ".723",
  stroke: "#DDE0E4",
  strokeWidth: "2",
  mask: "url(#a)"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip2_1966_115412)"
}, /*#__PURE__*/React.createElement("rect", {
  x: ".361",
  y: "32.861",
  width: "37.277",
  height: "27.057",
  rx: ".639",
  fill: "#FAFAFA"
}), /*#__PURE__*/React.createElement("rect", {
  x: "2.5",
  y: "35",
  width: "5",
  height: "5",
  rx: ".5",
  stroke: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "15",
  y: "39.5",
  width: "8",
  height: "8",
  rx: "1",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "4",
  y: "50.5",
  width: "30",
  height: "2.89",
  rx: ".723",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: ".361",
  y: "32.861",
  width: "37.277",
  height: "27.057",
  rx: ".639",
  stroke: "#DDE0E4",
  strokeWidth: ".723"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip3_1966_115412)"
}, /*#__PURE__*/React.createElement("rect", {
  x: "42.5",
  y: "33",
  width: "37",
  height: "26.78",
  rx: ".5",
  fill: "#FAFAFA"
}), /*#__PURE__*/React.createElement("rect", {
  x: "44.5",
  y: "35",
  width: "5",
  height: "5",
  rx: ".5",
  stroke: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "57",
  y: "39.5",
  width: "8",
  height: "8",
  rx: "1",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "46",
  y: "50.5",
  width: "30",
  height: "2.89",
  rx: ".723",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "42.5",
  y: "33",
  width: "37",
  height: "26.78",
  rx: ".5",
  stroke: "#DDE0E4"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1966_115412"
}, /*#__PURE__*/React.createElement("rect", {
  y: ".721",
  width: "38",
  height: "27.78",
  rx: "1",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_1966_115412"
}, /*#__PURE__*/React.createElement("rect", {
  x: "42",
  y: ".721",
  width: "38",
  height: "27.78",
  rx: "1",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip2_1966_115412"
}, /*#__PURE__*/React.createElement("rect", {
  y: "32.5",
  width: "38",
  height: "27.78",
  rx: "1",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip3_1966_115412"
}, /*#__PURE__*/React.createElement("rect", {
  x: "42",
  y: "32.5",
  width: "38",
  height: "27.78",
  rx: "1",
  fill: "#fff"
})))));